export default __webpack_public_path__ + "static/media/img1.dea574a0.jpg";